import {
    Lesson,
    PrepLesson,
    PrepLessonDetails as PrepLessonDetailsServerSide,
    Theme,
    ThemeDetails,
} from '@yandex-int/k-common/typings';
import { DEFAULT_PAGE_TO_LOAD } from 'platform-components/constants';
import { withRouterPath, InjectedProps as WithRouterPathProps } from 'platform-components/hocs';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { getCurrentYearCourseId } from 'common.components/course/selectors';
import withTime, { InjectedProps as WithTimeProps } from 'common.components/timer/withTime';
import { prepLessonsActions } from 'store/prep-lessons/actions';
import * as themesActions from 'store/themes/actions';

import { ReduxTeacherStore, RootAction } from '../../typings';
import * as storeActions from '../library.store/actions';

import { LibraryPromoPageContainer } from './promo';

interface StoreProps {
    subject: string;
    themeId: number;
    courseId: number | null;
}

interface DispatchProps {
    getThemeDetailsSuccess: typeof storeActions.getThemeDetailsSuccess;
    getThemesTreeSuccess: typeof themesActions.getThemesTreeSuccess;
    getRootThemesSuccess: typeof themesActions.getRootThemesSuccess;
    loadPrepLessonsSuccess: typeof prepLessonsActions.loadPrepLessonsSuccess;
    loadPrepLessonsDetailsSuccess: typeof prepLessonsActions.loadPrepLessonsDetailsSuccess;
}

interface Props extends WithRouterPathProps, WithTimeProps, StoreProps, DispatchProps {}

interface Context {
    data: {
        getThemeDetails: ThemeDetails;
        getThemesFlatFullTree: Array<Theme>;
        getThemesFlat: Array<Theme>;
        getPrepLessons: {
            next: string;
            results: Array<PrepLesson>;
        };
        getPrepLessonsDetails: Array<PrepLessonDetailsServerSide>;
    };
    initialRender: boolean;
}

// компонент классовый, так как хуки не отрабатывают на SSR
class LibraryPromoSSR extends React.Component<Props> {
    static contextTypes = {
        data: PropTypes.object.isRequired,
        initialRender: PropTypes.bool,
    };

    // eslint-disable-next-line complexity
    constructor(props: Props, context: Context) {
        super(props);

        const {
            subject,
            themeId,
            courseId,

            getThemeDetailsSuccess,
            getRootThemesSuccess,
            getThemesTreeSuccess,
            loadPrepLessonsSuccess,
            loadPrepLessonsDetailsSuccess,
        } = props;

        const {
            data: {
                getThemeDetails: ssrThemeDetails,
                getThemesFlat: ssrThemesFlat,
                getThemesFlatFullTree: ssrFilters,
                getPrepLessons: ssrPrepLessons,
                getPrepLessonsDetails: ssrPrepLessonsDetails,
            },
            initialRender,
        } = context;

        if (initialRender) {
            if (themeId && ssrThemeDetails) {
                getThemeDetailsSuccess(themeId, ssrThemeDetails);
            }

            if (themeId && ssrThemesFlat) {
                getRootThemesSuccess(subject, ssrThemesFlat);
            }

            if (themeId && ssrFilters) {
                getThemesTreeSuccess(subject, themeId, ssrFilters, themeId);
            }

            const lessons: Lesson[] = (ssrPrepLessons?.results || []).map(({ lesson }: PrepLesson) => lesson);
            const next = ssrPrepLessons?.next;
            const canLoadMore = next !== null;
            loadPrepLessonsSuccess({ lessons, themeId, page: DEFAULT_PAGE_TO_LOAD, canLoadMore });

            if (ssrPrepLessonsDetails && courseId) {
                const lessonsIds = ssrPrepLessonsDetails.map((lesson) => lesson.id);
                loadPrepLessonsDetailsSuccess({
                    details: ssrPrepLessonsDetails,
                    courseId,
                    lessonsIds,
                });
            }
        }
    }

    render() {
        return <LibraryPromoPageContainer />;
    }
}

const mapStateToProps = (storeState: ReduxTeacherStore, ownProps: WithRouterPathProps) => {
    const {
        match: {
            params: { themeId: thId, subject },
        },
    } = ownProps;
    const themeId = Number(thId);

    return {
        subject,
        themeId,
        courseId: getCurrentYearCourseId(storeState),
    };
};

const mapDispatchToProps = (dispatch: Dispatch<RootAction>): DispatchProps => {
    return bindActionCreators(
        {
            getThemeDetailsSuccess: storeActions.getThemeDetailsSuccess,
            getThemesTreeSuccess: themesActions.getThemesTreeSuccess,
            getRootThemesSuccess: themesActions.getRootThemesSuccess,
            loadPrepLessonsSuccess: prepLessonsActions.loadPrepLessonsSuccess,
            loadPrepLessonsDetailsSuccess: prepLessonsActions.loadPrepLessonsDetailsSuccess,
        },
        dispatch
    );
};

// дополнительный компонент нужен для того, чтобы на ssr положить в стор данные здесь, а забрать уровнем ниже.
// на не-SSR загрузку данных это не влияет
export const LibraryPromoSSRContainer = withRouterPath(
    withTime(connect(mapStateToProps, mapDispatchToProps)(LibraryPromoSSR))
);
